import {notifications} from '@mantine/notifications'

export const showNotification = (successMessage: string | undefined, errorMessage: string) => {
  return {
    onSuccess: () => successMessage && notifications.show({message: successMessage, color: 'green'}),
    onError: () => notifications.show({message: errorMessage, color: 'red'}),
  }
}
